import React from "react";
import hide from "../../images/hide.png";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useMutation } from "@apollo/react-hooks";
import { LOGIN } from "../../mutation/login";
import LoginLayout from "../Login/LoginLayout";
import { Link } from "react-router-dom";
import logout from "../../images/logout-icon.png";
import * as Yup from "yup";
import { hasuraClient } from "../../apolloClient";
import { DELETE_USER } from "../../mutation/deleteUser";
import DeleteEvent from "../Popup/DeleteEvent";

const LogoutPopup = (props) => {
  const onClickLogoutBtn = () => {
    localStorage.clear();
    window.location.href = "/delete-user";
  };
  return (
    <Modal
      className="logoutpop"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <h4>Are you sure you want to log out?</h4>
        <div className="logout-image">
          <img src={logout} alt="logout background" />
        </div>

        <div className="logoutpop-body">
          <div className="cancel-popup">
            <button onClick={props.onHide}>cancel</button>
          </div>
          <div className="logout-popup">
            <button onClick={onClickLogoutBtn}>Yes, logout</button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const DeleteEndUserAccount = () => {
  const [Login] = useMutation(LOGIN);
  const [isDeleteAccountVisible, setIsDeleteAccountVisible] =
    React.useState(false);
  const [visiblePassword, setVisiblePassword] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowD, setModalShowD] = React.useState(false);
  const [successVisible, setSuccessVisible] = React.useState(
    localStorage.getItem("resetPassword")
  );

  const [DeleteUser] = useMutation(DELETE_USER, {
    client: hasuraClient,
  });

  const successNotify = () => {
    if (successVisible) {
      return (
        <div
          style={{
            padding: 17,
            width: "100%",
            backgroundColor: "#CCEEDF",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: "36.7px",
          }}
        >
          <svg
            style={{ marginRight: 10 }}
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M6.99967 13.6666C3.31778 13.6666 0.333008 10.6818 0.333008 6.99992C0.333008 3.31802 3.31778 0.333252 6.99967 0.333252C10.6816 0.333252 13.6663 3.31802 13.6663 6.99992C13.6623 10.6801 10.6799 13.6625 6.99967 13.6666ZM6.98901 12.3333H6.99967C9.94415 12.3303 12.3291 9.94173 12.3277 6.99725C12.3262 4.05278 9.93882 1.66659 6.99434 1.66659C4.04986 1.66659 1.66248 4.05278 1.66101 6.99725C1.65954 9.94173 4.04453 12.3303 6.98901 12.3333ZM5.66634 10.3333L2.99967 7.66659L3.93967 6.72659L5.66634 8.44659L10.0597 4.05325L10.9997 4.99992L5.66634 10.3333Z"
              fill="#161F3D"
            />
          </svg>
          <p style={{ margin: 0, fontSize: 14, lineHeight: "16px" }}>
            Your password has been changed. Sign in again.
          </p>
        </div>
      );
    } else {
      return null;
    }
  };

  const changeState = () => {
    setSuccessVisible(false);
    localStorage.setItem("resetPassword", false);
  };

  const deleteUserHandler = () => {
    const user_id = localStorage.getItem("user_id") || "";
    if (user_id) {
      DeleteUser({
        variables: {
          id: user_id,
        },
      })
        .then((res) => {
          if (res?.data?.delete_users?.affected_rows > 0) {
            localStorage.clear();
            window.location.href = "/delete-user";
          }
          setModalShowD(false);
        })
        .catch((e) => {
          setModalShowD(false);
          console.error("error in deleting the account", e);
        });
    }
  };

  const LoginPasswordForm = (
    <LoginLayout>
      <div className="login-cover">
        <div className="login-box">
          <h1>Login</h1>
          {successVisible === "true" ? successNotify() : null}
          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={Yup.object({
              email: Yup.string()
                .email("Invalid Email Address")
                .required("Please enter your email"),
              password: Yup.string().required("Please enter your password"),
            })}
            onSubmit={(values, { setFieldError, setSubmitting }) => {
              Login({
                variables: {
                  email: values.email,
                  password: values.password,
                  full_name: values.fullname,
                  role: "END_USER",
                },
              })
                .then(async (response) => {
                  const { accessToken } = response.data.userLogin;
                  localStorage.setItem("jwt_token", accessToken);
                  localStorage.setItem(
                    "user_id",
                    response?.data?.userLogin?.data?.userId
                  );
                  localStorage.setItem(
                    "end_user_role",
                    response?.data?.userLogin?.data?.role
                  );

                  setIsDeleteAccountVisible(true);
                  setSubmitting(false);
                })
                .catch((e) => {
                  const errors = e.graphQLErrors;
                  if (errors[0]?.errorCode === "INCORRECT_PASSWORD") {
                    setFieldError("password", errors[0].message);
                  } else if (errors[0] && errors[0].message) {
                    setFieldError("email", errors[0].message);
                  }

                  setSubmitting(false);
                });
            }}
          >
            {({ isSubmitting }) => (
              <Form className="login-form">
                <div className="form-group">
                  <label>Email</label>
                  <Field
                    onClick={changeState}
                    type="email"
                    name="email"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group password-row">
                  <label>Password</label>
                  <div className="hide-icon">
                    <Field
                      type={visiblePassword ? "text" : "password"}
                      name="password"
                      className="form-control"
                    />
                    <img
                      onClick={() => setVisiblePassword(!visiblePassword)}
                      src={hide}
                      alt="password hide"
                    />
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group remeber-row">
                  <label className="checkbox">
                    Remember Me
                    <input type="checkbox" />
                    <span className="checkmark"></span>
                  </label>
                  <div className="forgot-password">
                    <Link to="/reset-password">Forgot Password</Link>
                  </div>
                </div>
                <div className="form-submit">
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isSubmitting}
                  >
                    Login
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </LoginLayout>
  );

  if (
    localStorage.getItem("end_user_role") === "end_user" &&
    (localStorage.getItem("jwt_token") || isDeleteAccountVisible)
  ) {
    return (
      <LoginLayout>
        <LogoutPopup show={modalShow} onHide={() => setModalShow(false)} />
        <DeleteEvent
          deleteEventHandler={deleteUserHandler}
          show={modalShowD}
          onHide={() => setModalShowD(false)}
          deleteObjectName="account"
        />
        <div className="login-cover">
          <div className="login-box">
            <h1>Are you sure you want to delete the account?</h1>
            <button
              type="button"
              className="submit-btn"
              style={{
                backgroundColor: "rgba(255,0,0, 0.9)",
              }}
              onClick={() => setModalShowD(true)}
            >
              Delete Account
            </button>
            <button
              type="button"
              className="submit-btn mt-5"
              onClick={() => setModalShow(true)}
            >
              Logout
            </button>
          </div>
        </div>
      </LoginLayout>
    );
  } else {
    return LoginPasswordForm;
  }
};

export default DeleteEndUserAccount;
